import {BrowserRouter, Route, Routes} from "react-router-dom";
import {MainLayout} from "./MainLayout";
import {Home} from "../pages/Home";
import {GetStarted} from "../pages/GetStarted";
import {TakeSelfie} from "../pages/TakeSelfie";
import {Payment} from "../pages/Payment";
import {Results} from "../pages/Results";
import {Alert} from "@mantine/core";
import { IconInfoCircle } from '@tabler/icons-react';

export const Layout = () => {
    return (
        <>
            {/*<Alert variant="filled" color="blue" title="NOTICE" icon={<IconInfoCircle />}>*/}
            {/*    Our main shop is under maintenance. We will back online in 24 hours to serve your beauty needs.*/}
            {/*</Alert>*/}
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<MainLayout/>}>
                        <Route index element={<Home/>}/>
                        <Route path="get-started"
                               element={<GetStarted/>}/>
                        <Route path="take-selfie"
                               element={<TakeSelfie/>}/>
                        <Route path="payment/:id"
                               element={<Payment/>}/>
                        <Route path="results/:id"
                               element={<Results/>}/>
                    </Route>
                </Routes>
            </BrowserRouter>
        </>
    )
}
